import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ProductData } from 'lib/types'
import { Alert, EmptyContainer, Spinner } from 'lib/ui'
import { NotFound } from 'lib/shared'
import { ComparisonProvider, useProductByPath } from 'lib/modules/catalog'

interface Props {
  children: (props: { product: ProductData }) => JSX.Element
}

export const ProductResolver = ({ children }: Props) => {
  const { product, isError, isFetching } = useProductByPath({ enableGTM: true })

  if (isError) {
    return (
      <EmptyContainer>
        <Alert>
          <FormattedMessage
            id='catalog.product.view.failure'
          />
        </Alert>
      </EmptyContainer>
    )
  }

  if (!product && !isFetching) {
    return (
      <NotFound />
    )
  }

  if (!product) {
    return (
      <EmptyContainer>
        <Spinner />
      </EmptyContainer>
    )
  }

  return (
    <ComparisonProvider>
      {children({ product })}
    </ComparisonProvider>
  )
}
